import React from "react";

type Props = {};

const Footer = (props: Props) => {
  return (
    <div className="mt-5 mb-2 text-center">
      <span className="h6">Made with ♥ by Hatim Patrawala</span>
    </div>
  );
};

export default Footer;
